/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import PropTypes from "prop-types";
import { QueryClient, QueryClientProvider } from "react-query";
import {
  createMuiTheme,
  MuiThemeProvider,
  StylesProvider,
} from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ConfigContextProvider, useConfig } from "./config/configContext";
import { theme as baseTheme } from "./config/theme";

const queryClient = new QueryClient();

export const AppProviders = ({ children }) => {
  const { theme: themeOverrides } = useConfig();
  const theme = createMuiTheme({ ...baseTheme, ...themeOverrides });

  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <ConfigContextProvider>
              <CssBaseline />
              {children}
            </ConfigContextProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  );
};

AppProviders.propTypes = {
  children: PropTypes.any.isRequired,
};
